import { Component, input, output } from '@angular/core';
import { Device } from '@rocksoft/shared';
import { DeviceGridComponent } from '../../device-grid/device-grid.component';

@Component({
  selector: 'era-devices-state-list-ui',
  templateUrl: './devices-state-list.component.html',
  imports: [DeviceGridComponent],
})
export class DevicesStateListComponent {
  readonly devices = input.required<Device[]>();
  readonly title = input.required<string>();
  readonly emptyMessage = input.required<string>();
  readonly selected = output<Device>();
}
